export default "__VITE_ASSET__NFzbaW5x__"